/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FilterOptionLayout {
    DEFAULT = 'default',
    COLORS = 'colors',
    PERSONALIZATION = 'personalization',
}
